import "./module/userAgentChecker"
import "./module/plugin"

import Swiper from "swiper/bundle";
const swiper = new Swiper('.mv__slider', {
    slidesPerView: 'auto',
    spaceBetween: 70,
    centeredSlides: true,
    speed: 2500,
    loop:true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    }
});
